<template>
  <div :class="classes" @click="onClick">
    <div class="trbo-a-question-progress-bar-item__dot" />
    <button class="trbo-a-question-progress-bar-item__label">
      {{ wizardPage.title }}
    </button>
  </div>
</template>

<script>
// @flow

export default {
  props: {
    wizardPage: {
      type: Object, // WizardPage
      required: true
    },
    completed: {
      type: Boolean,
      default: false
    },
    current: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes () {
      return {
        group: true,
        'trbo-a-question-progress-bar-item': true,
        'trbo-a-question-progress-bar-item--completed': this.completed,
        'trbo-a-question-progress-bar-item--current': this.current
      }
    }
  },
  methods: {
    onClick () {
      this.$emit('click', this.wizardPage)
    }
  }
}
</script>

<style scoped src="./question-progress-bar-item.scss" />
